import React from 'react'
import SliderOurFleets from '../../component/SliderOurFleets'

const OurFleets = () => {
    return (
        <>
            <div className="container-fluid service overflow-hidden pt-5" style={{ marginTop: "-120px" }}>
                <div className="container py-5">
                    <div className="section-title text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
                        <div className="sub-style">
                            <h5 className="sub-title text-primary px-3">Shiv Travels Taxi Services</h5>
                        </div>
                        <h1 className="display-5 mb-4">Explore Some Nearest Places</h1>
                        
                    </div>
                    <div className="row g-4">
                        <div className="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="service-item">
                                <div className="service-inner">
                                    <div className="service-img">
                                        <img src="./assets/img/chitrakoot-dham.webp" className="img-fluid w-100 rounded" alt="Image" />
                                    </div>
                                    <div className="service-title">
                                        <div className="service-title-name">
                                            <div className="bg-primary text-center rounded p-3 mx-5 mb-4">
                                                <a to="#" className="h4 text-white mb-0">Chitrakoot Dham</a>
                                            </div>
                                            {/* <a className="btn bg-light text-secondary rounded-pill py-3 px-5 mb-4" to="#">Explore
                                                More</a> */}
                                        </div>
                                        {/* <div className="service-content pb-4">
                                            <a to="#">
                                                <h4 className="text-white mb-4 py-3">Job Visa</h4>
                                            </a>
                                            <div className="px-4">
                                                <p className="mb-4">Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                                                    Mollitia fugit dolores nesciunt adipisci obcaecati veritatis cum, ratione
                                                    aspernatur autem velit.</p>
                                                <a className="btn btn-primary border-secondary rounded-pill py-3 px-5" to="#">Explore More</a>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="service-item">
                                <div className="service-inner">
                                    <div className="service-img">
                                        <img src="./assets/img/Maihar Mata.webp" className="img-fluid w-100 rounded" alt="Image" />
                                    </div>
                                    <div className="service-title">
                                        <div className="service-title-name">
                                            <div className="bg-primary text-center rounded p-3 mx-5 mb-4">
                                                <a to="#" className="h4 text-white mb-0">Maihar Mata</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="service-item">
                                <div className="service-inner">
                                    <div className="service-img">
                                        <img src="./assets/img/Khajuraho.webp" className="img-fluid w-100 rounded" alt="Image" />
                                    </div>
                                    <div className="service-title">
                                        <div className="service-title-name">
                                            <div className="bg-primary text-center rounded p-3 mx-5 mb-4">
                                                <a to="#" className="h4 text-white mb-0">Khajuraho</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="service-item">
                                <div className="service-inner">
                                    <div className="service-img">
                                        <img src="./assets/img/Ujjain Mahakal.AVIF" className="img-fluid w-100 rounded" alt="Image" />
                                    </div>
                                    <div className="service-title">
                                        <div className="service-title-name">
                                            <div className="bg-primary text-center rounded p-3 mx-5 mb-4">
                                                <a to="#" className="h4 text-white mb-0">Ujjain Mahakal</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="service-item">
                                <div className="service-inner">
                                    <div className="service-img">
                                        <img src="./assets/img/Prayagraj.webp" className="img-fluid w-100 rounded" alt="Image" />
                                    </div>
                                    <div className="service-title">
                                        <div className="service-title-name">
                                            <div className="bg-primary text-center rounded p-3 mx-5 mb-4">
                                                <a to="#" className="h4 text-white mb-0">Prayagraj</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="service-item">
                                <div className="service-inner">
                                    <div className="service-img">
                                        <img src="./assets/img/Varanasi.webp" className="img-fluid w-100 rounded" alt="Image" />
                                    </div>
                                    <div className="service-title">
                                        <div className="service-title-name">
                                            <div className="bg-primary text-center rounded p-3 mx-5 mb-4">
                                                <a to="#" className="h4 text-white mb-0">Varanasi</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="service-item">
                                <div className="service-inner">
                                    <div className="service-img">
                                        <img src="./assets/img/Jabalpur Bhedaghat.webp" className="img-fluid w-100 rounded" alt="Image" />
                                    </div>
                                    <div className="service-title">
                                        <div className="service-title-name">
                                            <div className="bg-primary text-center rounded p-3 mx-5 mb-4">
                                                <a to="#" className="h4 text-white mb-0">Bhedaghat</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="service-item">
                                <div className="service-inner">
                                    <div className="service-img">
                                        <img src="./assets/img/Bageshwar Dham.webp" className="img-fluid w-100 rounded" alt="Image" />
                                    </div>
                                    <div className="service-title">
                                        <div className="service-title-name">
                                            <div className="bg-primary text-center rounded p-3 mx-5 mb-4">
                                                <a to="#" className="h4 text-white mb-0">Bageshwar Dham</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="service-item">
                                <div className="service-inner">
                                    <div className="service-img">
                                        <img src="./assets/img/Ayodhya.webp" className="img-fluid w-100 rounded" alt="Image" />
                                    </div>
                                    <div className="service-title">
                                        <div className="service-title-name">
                                            <div className="bg-primary text-center rounded p-3 mx-5 mb-4">
                                                <a to="#" className="h4 text-white mb-0">Ayodhya</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="service-item">
                                <div className="service-inner">
                                    <div className="service-img">
                                        <img src="./assets/img/Panna Tiger Reserve.webp" className="img-fluid w-100 rounded" alt="Image" />
                                    </div>
                                    <div className="service-title">
                                        <div className="service-title-name">
                                            <div className="bg-primary text-center rounded p-3 mx-5 mb-4">
                                                <a to="#" className="h4 text-white mb-0">Panna Tiger </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="service-item">
                                <div className="service-inner">
                                    <div className="service-img">
                                        <img src="./assets/img/White Tiger Safari.webp" className="img-fluid w-100 rounded" alt="Image" />
                                    </div>
                                    <div className="service-title">
                                        <div className="service-title-name">
                                            <div className="bg-primary text-center rounded p-3 mx-5 mb-4">
                                                <a to="#" className="h4 text-white mb-0">White Tiger Safari</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-xl-4 wow fadeInUp" data-wow-delay="0.3s">
                            <div className="service-item">
                                <div className="service-inner">
                                    <div className="service-img">
                                        <img src="./assets/img/Purwa Water Fall.webp" className="img-fluid w-100 rounded" alt="Image" />
                                    </div>
                                    <div className="service-title">
                                        <div className="service-title-name">
                                            <div className="bg-primary text-center rounded p-3 mx-5 mb-4">
                                                <a to="#" className="h4 text-white mb-0">Purwa Water Fall</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                      
                    </div>
                </div>
            </div>



        </>
    )
}

export default OurFleets